export const NEAR_BOTTOM_PX = 80;

export function distanceFromBottom({ scrollTop, scrollHeight, clientHeight }) {
  return scrollHeight - scrollTop - clientHeight;
}

export function isNearBottom(metrics, threshold = NEAR_BOTTOM_PX) {
  return distanceFromBottom(metrics) <= threshold;
}

// A scroll position we wrote ourselves should never change follow intent.
export function isProgrammaticScroll(scrollTop, lastProgrammaticTop, tolerance = 2) {
  return lastProgrammaticTop != null && Math.abs(scrollTop - lastProgrammaticTop) <= tolerance;
}

// Single reducer for "should we keep following the bottom?"
export function nextFollowState({ following, metrics, lastProgrammaticTop, threshold = NEAR_BOTTOM_PX }) {
  if (isProgrammaticScroll(metrics.scrollTop, lastProgrammaticTop)) return following;
  return isNearBottom(metrics, threshold);
}
